import config from '@/const/const.js'
import util from '@/mixins/util.js'
const constant = config.constant

/**
 * ログイン方法データを登録/更新
 * @param {String} data ログイン設定
 */
export function setLoginMethod(data) {
  util.methods.setLocalStorage(constant.LOGIN_SETTING_KEY, data)
}
/**
 * ログイン方法データを取得
 * @returns 取得結果
 */
export function getLoginMethod() {
  return util.methods.getLocalStorage(constant.LOGIN_SETTING_KEY)
}
/**
 * 既にアプリ内情報が作成されているかの判定処理
 * @returns 判定結果
 */
export function isSetAppInfo() {
  // ローカルストレージのアプリ内情報取得
  const appInfo = util.methods.getLocalStorage(constant.APP_INFO_KEY)
  // アプリ内情報自体が作成されているかを返却
  return !util.methods.isNull(appInfo)
}
